function updateQueryStringParameter(uri, key, value) {
  const reg = new RegExp("([?&])".concat(key, "=.*?(&|$)"), 'i');
  const separator = uri.indexOf('?') === -1 ? '?' : '&';
  if (uri.match(reg)) {
    return uri.replace(reg, "$1".concat(key, "=").concat(value, "$2"));
  }
  return "".concat(uri).concat(separator).concat(key, "=").concat(value);
}
export default {
  updateQueryStringParameter
};